import axios from "axios";
import {
  SEND_CONTACT_EMAIL,
  GET_CSRF_TOKEN,
  GET_SERVER_DATE_TIME
} from "./types";

export const sentContactEmail = (values, csrf) => async dispatch => {
  const res = await axios.post("/api/send_contact_email", { values, csrf });
  if (res.data.error) {
  } else {
    dispatch({ type: SEND_CONTACT_EMAIL, payload: res.data });
  }
};

export const fetchCsrf = () => async dispatch => {
  const res = await axios.get("/api/get_csrf");
  dispatch({ type: GET_CSRF_TOKEN, payload: res.data });
};

export const getServerDateTime = () => async dispatch => {
  const res = await axios.get("/api/get_server_time");
  dispatch({ type: GET_SERVER_DATE_TIME, payload: res.data });
};
